import { Popover } from "tailwindcss-stimulus-components";

export default class extends Popover {
  static values = {
    popoverClicked: { type: Boolean, default: false },
  };

  onClick() {
    if (this.popoverClickedValue || !this.openValue) {
      this.toggle();
    }

    this.popoverClickedValue = this.openValue;
  }

  onMouseEnter() {
    if (!this.popoverClickedValue) {
      this.show();
    }
  }

  onMouseLeave() {
    if (!this.popoverClickedValue) {
      this.hide();
    }
  }

  close() {
    this.popoverClickedValue = false;
    this.hide();
  }
}
